<template>
  <div>
    <el-select :value="selected" @input="dispatch" :placeholder="placeholder || $t('message.skill')" filterable clearable :multiple="multiple"
      :size="size" class="d-block">
      <el-option v-for="(skill,index) in skills" :key="'skills-' + index" :label="skill.skill" :value="skill.id"></el-option>
    </el-select>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from "vuex";
  import { i18n  } from '@/utils/i18n';
  export default {
    props: {
        size: {
            default: 'small'
        },
        placeholder: {
            default: null,
        },
        id:{
          default: null
        },
        multiple:{
            type: Boolean,
            default: false,
        }
    },
     watch:{
      id:{
        handler: function() {
            this.selected = this.id
        },
        immediate: true
      }
    },
    data() {
      return {
        selected: null,
      }
    },
    mounted() {
      if (this.skills && this.skills.length === 0) this.updateInventory()
    },
    computed: {
      ...mapGetters({
        skills: 'skill/inventory'
      })
    },
    methods: {
      ...mapActions({
        updateInventory: 'skill/inventory'
      }),
      dispatch(e) {
        this.$emit('input', e)
        this.selected = e
      }
    },
  }

</script>
